/**
 * Product groups shared by the page-helper leaves and the complete offering
 * group classifier.
 *
 * Keep this module dependency-free so page predicates do not import the full
 * `settings/offerings` catalogue.
 */
type PageOfferingGroup = 'BookTypes' | 'CardGame' | 'PhotoFrameBox' | 'PhotoSheets' | 'PrintTypes';

/**
 * Product group ids shared with `settings/offerings` (productgroup table in
 * the order fulfillment database). Only the ids the page helpers classify
 * live here; the full catalogue stays in `settings/offerings`, which imports
 * these back so each id is defined once.
 */
export const PG_BOOKS = 101;
export const PG_SINGLE_SIDED_PRINTS = 103;
export const PG_DOUBLE_SIDED_PRINTS = 105;
export const PG_PANEL_CARDS = 106;
export const PG_SINGLE_MAGNETS = 110;
export const PG_YEAR_AGENDAS = 111;
export const PG_PLAYING_CARDS = 113;
export const PG_SCHOOL_AGENDAS = 120;
export const PG_LAY_FLAT_BOOKS = 121;
export const PG_SOCIAL_BOOKS = 122;
export const PG_PHOTOBLOCKS = 135;
export const PG_PHOTO_FRAME_BOX = 137;
export const PG_MULTI_PRINTS = 139;
export const PG_MULTI_ENLARGEMENTS = 148;
export const PG_PHOTOSHEETS = 155;

export const PAGE_OFFERING_GROUP_IDS: Record<PageOfferingGroup, readonly number[]> = {
	BookTypes: [
		PG_BOOKS,
		PG_YEAR_AGENDAS,
		PG_SCHOOL_AGENDAS,
		PG_LAY_FLAT_BOOKS,
		PG_SOCIAL_BOOKS,
	],
	CardGame: [PG_PLAYING_CARDS],
	PhotoFrameBox: [PG_PHOTO_FRAME_BOX],
	PhotoSheets: [PG_PHOTOSHEETS],
	PrintTypes: [
		PG_SINGLE_SIDED_PRINTS,
		PG_DOUBLE_SIDED_PRINTS,
		PG_SINGLE_MAGNETS,
		PG_PHOTOBLOCKS,
		PG_PHOTO_FRAME_BOX,
		PG_MULTI_PRINTS,
		PG_MULTI_ENLARGEMENTS,
		PG_PHOTOSHEETS,
	],
};
